/**
 * Created by swchen on 2017/2/14.
 */


import queryString from "query-string";
import _ from "lodash";
import {message, Modal} from "antd";
import dayjs from "dayjs";
import {update, reset} from "../../viewmodel/mainViewModel";
import UserPermissionService from "../../service/core/UserPermissionService";
import UserService from "../../service/core/UserService";
import DepartmentService from "../../service/core/DepartmentService";
import DingdingService from "../../service/noAuth/DingdingService";
import AuthDingdingService from "../../service/auth/DingdingService";
import HospitalService from "../../service/core/HospitalService";
import DictionaryService from "../../service/core/DictionaryService";

import AppContext from "../../application/AppContext";
import DingTalkUtil, {isNotInDingTalk} from "../../util/DingTalkUtil";


import BaseUtil from "../../util/BaseUtil";
import Constants from "../../constant/Constants";

import MenuConfig from "../../view/main/MenuConfig";
import CorpSyncService from "../../service/core/CorpSyncService";
import HelpService from "../../service/help/HelpService";
import ConfigService from "../../service/renyuan/rpc/ConfigService";
import BusinessConstants from "../../constant/BusinessConstants";
import SsoService from "../../service/noAuth/SsoService";
import RolePermService from "../../service/RolePermService";
import NoAuthHospitalService from "../../service/noAuth/nursecarecore/HospitalService";
import NoAuthUnderlayService from "../../service/noAuth/UnderlayService";
import TokenService from "../../service/sso/TokenService";
import SmsService from "../../service/noAuth/nursecare/SmsService";
import ArchiveService from "../../service/emp/archive/ArchiveService";
import PasswordService from "../../service/plt/PasswordService";
import PltService from "../../service/PltService";
import WxService from "../../service/noAuth/WxService";
import pkg from "../../../../../package.json";

const isSwjwMode = __IS_SWJW__;

function addParamsToSearch(search, additionalParam = {}) {
    // 分离查询参数和哈希部分
    const [queryPart, hashPart] = search.split("#");
    const params = new URLSearchParams(queryPart);
    params.delete("appid");
    // 将额外参数添加到 URLSearchParams 对象中
    for (const [key, value] of Object.entries(additionalParam)) {
        params.append(key, value);
    }
    // 重新组合查询参数和哈希部分
    const newQuery = params.toString();
    return hashPart ? `${newQuery}#${hashPart}` : newQuery;
}

const transformMenus = (list, baseUrl = "") => {
    return _.chain(list)
        .flatMap((item) => {
            const path = `${baseUrl}/${item.key}`;
            let result = [];
            if (item.children) {
                result = transformMenus(item.children, path);
            }

            if (item.component) {
                result.push({
                    pageIndex: path,
                    perm: {
                        perm: item.perm,
                    },
                });
            }

            return result;
        })
        .value();
};

const ssoLogin = async (token) => {
    const accessToken = await SsoService.loginAsync({
        token: decodeURIComponent(token),
    });
    AppContext.ssoAccessToken = accessToken;
};

const numasLogin = async (token) => {
    const accessToken = await SsoService.numasLoginAsync({
        token,
    });
    localStorage.setItem(Constants.TOKEN_NAME, accessToken);
};

function getData({navigate}) {
    return async (dispatch, getState) => {
        try {
            dispatch(update({
                isExecuting: true,
            }));

            let {corpid: corpId, param, module, type, nologin_redirect: noLoginRedirect, wxCorpId} = queryString.parse(location.search);
            const queryArg = queryString.parse(window.location.search);
            let platform = AppContext.constants.PLATFORM.DEFAULT;
            const embed = queryArg.embed === "true";
            let paramObj;
            if (!_.isEmpty(param)) {
                paramObj = queryString.parse(BaseUtil.base64Decode(param));
                if (paramObj != null) {
                    if (_.isEmpty(corpId)) {
                        // 兼容corpid在param里的情况
                        corpId = paramObj.corpid;
                    }
                    if (_.isEmpty(module)) {
                        // 兼容module在param里的情况
                        module = paramObj.module;
                    }

                    delete paramObj.corpid;
                    if (_.isEmpty(paramObj)) {
                        paramObj = null;
                    }
                }
            }


            if (queryArg.sso_token != null) {
                await ssoLogin(queryArg.sso_token);
            }

            if (queryArg.type === "numas") {
                // numas跳转登录
                await numasLogin(queryArg.token);
            }

            if (type === "wx") {
                if (!noLoginRedirect) {
                    const noLoginUrl = await WxService.getNoLoginUrlAsync({
                        wxCorpId,
                        pc: true,
                    });
                    window.location.replace(noLoginUrl);
                } else {
                    const {success, code, data} = await WxService.noLoginAsync({
                        code: queryArg.code,
                        state: queryArg.state,
                        version: pkg.version,
                    });

                    if (!success && code === 10000) {
                        dispatch(update({
                            isExecuting: false,
                            isBindAccount: true,
                        }));
                        return;
                    }
                }
            }

            if (corpId != null) {
                // 在 DingTalk PC(钉钉桌面客户端) webview 环境下, query string 参数传入 corpid(企业id) 和 appid
                platform = AppContext.constants.PLATFORM.DINGDING;
                const _corpId = _.trim(corpId);
                await DingTalkUtil.readyAsync();
                const rst = await DingTalkUtil.requestAuthCodeAsync({
                    corpId: _corpId,
                });
                const res = await DingdingService.v2NoLoginAsync({
                    corpId: _corpId,
                    authCode: rst.code,
                    version: NURSECARE_COMPILE_INFO.VERSION,
                    type: NURSECARE_COMPILE_INFO.TYPE,
                }) || {};/*  */
                dispatch(update({
                    ddUserId: res.data.ddUserId,
                    ddCorpId: res.data.ddCorpId,
                }));
                if (!AppContext.isSwjw) {
                    const hospitalConfig = await NoAuthHospitalService.getHospitalConfigAsync({
                        ddCorpId: res.data.ddCorpId,
                    });
                    AppContext.hospitalConfig = hospitalConfig;
                }
                if (res.code === 10000) {
                    dispatch(update({
                        isExecuting: false,
                        isBindAccount: true,
                    }));
                    return;
                }
            }
        
            const hospital = await HospitalService.getHospitalAsync();
            const {expireDate} = hospital;
            const isExpired = dayjs().isAfter(dayjs(expireDate));
            if (isExpired) {
                return dispatch(update({
                    isExpired,
                }));
            }

            const user = await UserService.findUserAsync();
            window.isLFAdmin = user.isLFAdmin;
            let ddCorpId; let _corpId = user.hospital?.refId;

            if (_.startsWith(_corpId, "ding")) {
                ddCorpId = user.hospital.refId;
                _corpId = null;
            }

            if (AppContext.hospitalConfig == null && !AppContext.isSwjw) {
                const hospitalConfig = await NoAuthHospitalService.getHospitalConfigAsync({
                    ddCorpId,
                    corpId: _corpId,
                });
                AppContext.hospitalConfig = hospitalConfig;
            }

            if (module != null) {
                return dispatch(switchModule(
                    module,
                    paramObj ? queryString.stringify(paramObj) : "",
                    user));
            }

            if (isExpired) {
                const expiredDays = dayjs().diff(dayjs(user.hospital?.expireDate), "day");
                dispatch(update({
                    showExpireNotify: true,
                    isExpired: true,
                    expiredDays,
                }));
            } else {
                const lastNotifyDate = localStorage.getItem("LAST_NOTIFY_DATE");
                const leftDays = dayjs(user.hospital?.expireDate).diff(dayjs(), "day");
                if (dayjs().isAfter(dayjs(user.hospital?.expireDate).subtract(1, "month"))) {
                    if (lastNotifyDate == null || !dayjs().isSame(lastNotifyDate, "day")) {
                        localStorage.setItem("LAST_NOTIFY_DATE", dayjs().format("YYYY-MM-DD HH:mm:ss"));
                        dispatch(update({
                            showExpireNotify: true,
                            isExpired: false,
                            expiredDays: leftDays,
                        }));
                    }
                } else if (dayjs().isAfter(dayjs(user.hospital?.expireDate).subtract(2, "month"))) {
                    if (lastNotifyDate == null || !dayjs().isSame(lastNotifyDate, "week")) {
                        localStorage.setItem("LAST_NOTIFY_DATE", dayjs().format("YYYY-MM-DD HH:mm:ss"));
                        dispatch(update({
                            showExpireNotify: true,
                            isExpired: false,
                            expiredDays: leftDays,
                        }));
                    }
                }
            }


            const hospitalId = user.hospital?.id;
            localStorage.setItem("RENYUAN_HOSPITAL_ID", hospitalId);
            if (AppContext.isSwjw) {
                const swjwPermission = await RolePermService.findRolesByUserAsync();
                AppContext.swjwPermission = swjwPermission;
            }


            const [config, corpPerms, {perms, roles, indexPerm: indexPerms},
                apps, services, versionUpgradeVisible, archiveConfig] = await Promise.all(
                [
                    DictionaryService.getSysDictWithoutExceptionHandleAsync(),
                    UserPermissionService.allAuthPermissionsWithoutExceptionHandleAsync(),
                    UserPermissionService.myPermissionsWithoutExceptionHandleAsync(),
                    !AppContext.isSwjw && ConfigService.listCorpAppAsync({hospitalId}),
                    !AppContext.isSwjw && ConfigService.listRegistryServiceAsync({hospitalId, consumer: BusinessConstants.PRODUCT_TYPE.RENYUAN.code}),
                    DictionaryService.getConfigAsync({
                        hospitalId: user.hospital?.id,
                        key: "VERSION_UPGRADE_VISIABLE",
                    }),
                    !AppContext.isSwjw && ArchiveService.getConfigAsync(),
                ]);

            const menus = transformMenus(MenuConfig.menu, "#");
            AppContext.init({
                user,
                config,
                roles,
                indexPerms,
                corpPermissions: corpPerms,
                permissions: perms,
                menus,
                platform,
                apps,
                services,
                versionUpgradeVisible,
                archiveConfig,
            });

            const isShowGuide = localStorage.getItem("isShowGuide");
            dispatch(update({
                user,
                roles,
                permissions: perms,
                isShowGuide: isShowGuide == null
                    ? true
                    : JSON.parse(isShowGuide),
                embed,
            }));

            !AppContext.isSwjw && dispatch(findInstallStatus());
            !AppContext.isSwjw && dispatch(getDingSyn());
            // dispatch(findNowNotice());
        } catch (e) {
            console.error(e);
            dispatch(update({
                error: e,
            }));
            if (e.code === Constants.NO_AUTH_CODE) {
                Modal.error({
                    iconType: "null",
                    title: e.message,
                    onOk: () => redirect2AccountLogin(),
                });
            }
        } finally {
            dispatch(update({
                isExecuting: false,
            }));
        }
    };
}

function openInBrowser(noLoginExplorerPopup) {
    return async (dispatch, getState) => {
        const code = await AuthDingdingService.getPopLoginCodeAsync();

        const origin = window.location.origin;
        const pathname = window.location.pathname;
        const hash = window.location.hash;

        const queryArg = queryString.parse(location.search);

        const rst = BaseUtil.urlresolve(Constants.BASE_URL, "api/noAuth/dingding/auth/popLogin");
        const search = queryString.stringify({
            code,
            redirectUrl: `${origin}${pathname}?corpid=${queryArg.corpid}`,
        });

        const url = `${rst}?${search}`;

        // noLoginExplorerPopup = AppContext.config.get("NOLOGIN_EXPLORER_POPUP");
        if (noLoginExplorerPopup) {
            DingTalkUtil.openLinkAsync({
                url,
            });
        } else {
            location = url;
        }
    };
}

// 获取当前医院的启用信息
function findInstallStatus() {
    return async (dispatch, getState) => {
        const installStatus = await HospitalService.findInstallStatusAsync();
        dispatch(update({
            installStatus,
        }));
    };
}

// 获取是否开启同步钉钉人员组织架构
function getDingSyn() {
    return async (dispatch, getState) => {
        try {
            const loading = await CorpSyncService.getSyncUnitStatusAsync();
            if (loading) {
                dispatch(update({
                    dingSynProgress: 0,
                    dingSynVisible: true,
                }));
                let stop;
                stop = setInterval(() => dispatch(getSyncUnitStatus(stop)), 3000);
            } else {
                dispatch(update({
                    dingSynVisible: false,
                }));
            }
        } finally {

        }
    };
}

function switchModule(module, search, user) {
    return async (dispatch, getState) => {
        const redirectConfig = _.find(AppContext.hospitalConfig?.redirectConfigs, item => item.module === module);
        const res = await TokenService.getTokenAsync({
            userId: user.id,
        });
        const params = addParamsToSearch(search, {sso_token: encodeURIComponent(res?.token), embed: true, isUnderlayMode: true});
        const url = `${redirectConfig.pcHome}?${params}`;
        location.replace(url);
    };
}


// 获取同步钉钉人员组织架构进度
function getSyncUnitStatus(stop) {
    return async (dispatch, getState) => {
        try {
            const loading = await CorpSyncService.getSyncUnitStatusAsync();
            loading && dispatch(update({
                dingSynProgress: loading.percent,
                dingSynVisible: true,
            }));
            if (!loading) {
                stop && clearInterval(stop);
                message.success("同步成功！");
                dispatch(update({
                    selectNurseUnit: null,
                    dingSynVisible: false,
                }));
            }
        } finally {

        }
    };
}

/**
 * 获取加群的链接
 * @returns {function(...[*]=)}
 */
function getChatGroupUrl() {
    return async (dispatch, getState) => {
        const res = await HelpService.getChatGroupUrlAsync();
        const url = res || "https://qr.dingtalk.com/action/joingroup?code=v1,k1,SoIVvgoRBeQHWEr06DVUS4Y9NOuK4pQwggEeTkLG1wI=&_dt_no_comment=1&origin=11";
        if (DingTalkUtil.getPlatForm() === "dingding") {
            open(url);
        } else {
            dispatch(update({
                chatGroupQr: url,
            }));
        }
    };
}

const SMSCodeCountDown = () => {
    return async (dispatch, getState) => {
        const dataContext = getState().mainViewModel;
        const {SMSCodeStatus} = dataContext;
        if (SMSCodeStatus.seconds === 1) {
            dispatch(update({
                SMSCodeStatus: {
                    disable: false,
                    seconds: null,
                },
            }));
        } else {
            const {seconds} = SMSCodeStatus;
            dispatch(update({
                SMSCodeStatus: {
                    seconds: seconds - 1,
                },
            }));
            setTimeout(() => dispatch(SMSCodeCountDown()), 1000);
        }
    };
};

function getJoinSMSCode() {
    return async (dispatch, getState) => {
        const dataContext = getState().mainViewModel;
        const {mobile} = dataContext?.joinData;
        await SmsService.sendAsync({
            mobile,
            biz: "UNDERLAY_BIND_USER",
        });
        dispatch(update({
            SMSCodeStatus: {
                disable: true,
                seconds: 60,
            },
        }));
        dispatch(SMSCodeCountDown());
    };
}

function bindAccount() {
    return async (dispatch, getState) => {
        const dataContext = getState().mainViewModel;
        const {corpid} = queryString.parse(location.search);
        const {ddUserId, ddCorpId} = dataContext;
        const {mobile, SMSCode} = dataContext.joinData;
        try {
            dispatch(update({
                isBinding: true,
            }));
            await NoAuthUnderlayService.bindByMobileAsync({
                mobile,
                smsCode: SMSCode,
                ddUserId,
                ddCorpId,
            });
            dispatch(update({
                isBindAccount: false,
            }));
            dispatch(getData());
        } finally {
            dispatch(update({
                isBinding: false,
            }));
        }
    };
}

function logout() {
    return async (dispatch, getState) => {
        const fn = AppContext.isSwjw ? PltService.logoutAsync : PasswordService.logoutAsync;
        await fn();
        redirect2AccountLogin();
    };
}

const redirect2AccountLogin = () => {
    if (isSwjwMode) {
        const url = new URL("/renyuan/pc/unifiedlogin.html", location.origin);
        const hospitalId = localStorage.getItem("RENYUAN_HOSPITAL_ID");
        if (hospitalId) {
            url.searchParams.set("hospitalId", hospitalId);
        }
        location.replace(url.toString());
    } else {
        const newPathName = `${_.chain(location.pathname)
            .split("/")
            .slice(1)
            .dropRight(1)
            .join("/")
            .value()}/unifiedlogin.html`;
        const url = new URL(newPathName, location.origin);
        const hospitalId = localStorage.getItem("RENYUAN_HOSPITAL_ID");
        if (hospitalId) {
            url.searchParams.set("hospitalId", hospitalId);
            location.replace(url.toString());
        }
    }
};

export default {
    update,
    reset,
    getJoinSMSCode,
    getData,
    findInstallStatus,
    getSyncUnitStatus,
    getChatGroupUrl,
    bindAccount,
    logout,
};
